import { all, takeEvery } from 'redux-saga/effects'
import { GET_TOUR, GET_RANKING } from './constants'
import getTourFlow from './flows/get-tour-flow'
import getRankingFlow from './flows/get-ranking-flow'

export function* watchTourAndRanking() {
  yield all([takeEvery(GET_TOUR, getTourFlow), takeEvery(GET_RANKING, getRankingFlow)])
}
